import { Controller } from '@hotwired/stimulus';
import { application } from 'src';

application.register('dates-check', class extends Controller {
  static targets = ['field'];

  refreshDates({ target }) {
    target.checked ? this.#removeDateFromField(target.value) : this.#addDateFromField(target.value);
  }


  #removeDateFromField(date) {
    const selectedDates = JSON.parse(this.fieldTarget.value);
    let newSelectedDates = selectedDates;

    newSelectedDates[date] = false;
    this.fieldTarget.value = JSON.stringify(newSelectedDates);
  }

  #addDateFromField(date) {
    const selectedDates = JSON.parse(this.fieldTarget.value);
    let newSelectedDates = selectedDates;

    newSelectedDates[date] = true;
    this.fieldTarget.value = JSON.stringify(newSelectedDates);
  }
});
